import { render, staticRenderFns } from "./Flucs.vue?vue&type=template&id=6a9400cc"
import script from "./Flucs.vue?vue&type=script&lang=js"
export * from "./Flucs.vue?vue&type=script&lang=js"
import style0 from "./Flucs.vue?vue&type=style&index=0&id=6a9400cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports